import AppModal, { AppModalProps } from "@/common/components/Modals/AppModal";
import AppModalTitle from "@/common/components/Modals/AppModalTitle";

import AppModalContent from "../../../Modals/AppModalContent";
import {
  DamageCostEvaluationDamageCorrectionsDisplay,
  DamageCostEvaluationDamageCorrectionsDisplayProps,
} from "./DamageCostEvaluationDamageCorrectionsDisplay";

export interface OwnProps {
  subProps: DamageCostEvaluationDamageCorrectionsDisplayProps;
}

type Props = OwnProps & Omit<AppModalProps, "children">;

export default function DamageCostEvaluationDamageCorrectionsDisplayModal({
  subProps,
  ...dialogProps
}: Props) {
  return (
    <AppModal fullWidth maxWidth='lg' {...dialogProps}>
      {(params) => (
        <>
          <AppModalTitle onClose={params.close}>Damage corrections</AppModalTitle>
          <AppModalContent>
            <DamageCostEvaluationDamageCorrectionsDisplay {...subProps} />
          </AppModalContent>
        </>
      )}
    </AppModal>
  );
}
